/** Map a URL hostname to a short, friendly source label (Norwegian recipe blogs). */
export function hostToSourceLabel(url) {
  if (!url) return "";
  try {
    const host = new URL(url).hostname.toLowerCase().replace(/^www\./, "");
    const map = {
      "matprat.no": "Matprat",
      "godt.no": "Godt.no",
      "trinesmatblogg.no": "Trines matblogg",
      "gladkokken.no": "Gladkokken",
      "rema.no": "Rema 1000",
      "kokkelure.no": "Kokkelure",
      "meny.no": "Meny",
      "tine.no": "Tine",
      "bakeprosjektet.no": "Bakeprosjektet",
      "idagranjansen.com": "Ida Gran-Jansen",
      "oppskrift.klikk.no": "Oppskrift Klikk",
      "klikk.no": "Klikk",
    };
    return map[host] || host.replace(/\.(no|com|se|dk)$/, "");
  } catch { return ""; }
}
